// utils/ageGroups.js
export const AGE_GROUPS = [
  { key: "adult", label: "Adult" },
  { key: "youth", label: "Youth"},
  { key: "college", label: "College"},
  { key: "30_plus", label: "30+" },
  { key: "35_plus", label: "35+" },
  { key: "40_plus", label: "40+" },
  { key: "45_plus", label: "45+" },
  { key: "50_plus", label: "50+" },
  { key: "60_plus", label: "60+" },
  { key: "u6", label: "U6" },
  { key: "u8", label: "U8" },
  { key: "u10", label: "U10" },
  { key: "u12", label: "U12" },
  { key: "u14", label: "U14" },
  { key: "u16", label: "U16" },
  { key: "u18", label: "U18"},
  { key: "middle_school", label: "Middle School" },
  { key: "high_school", label: "High School" },
];

export const AGE_GROUP_LABELS = AGE_GROUPS.reduce((acc, g) => {
  acc[g.key] = g.label;
  return acc;
}, {});